function isDevelopment()
{
	return process.env.NODE_ENV === 'development'
}

function isLocal()
{
	return window.location.href.includes("localhost")
}
export function getUrl()
{
	if(isLocal())
	{
		return "http://localhost:3000/";
	}
	return "https://easy-flashcards.herokuapp.com/";
}

